import type { AutoUpgradeNotATrialModal as MessagePipe } from '@post-office/placement-common/pipes';
import {
	createClientPipeline,
	createServerPipeline,
} from '@post-office/placement-common/utils/create-pipeline';

import { type MessageTemplateContext } from '../../..';

export type HydrationResult = {
	envType: string;
	messageContext: MessageTemplateContext;
};

type Pipe = MessagePipe<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

export const { createRender, createValidate } = createClientPipeline<Pipe>();
export const { createHydrate, createHydrateExample, createTransformMetadata } =
	createServerPipeline<Pipe>();

export type Product = 'jira' | 'jira-service-management' | 'jira-product-discovery' | 'confluence';
